const getDaysBetweenDates = (a, b) => {
  if (!a || !b) {
    return 0;
  }
  const ms = Math.abs(new Date(a).getTime() - new Date(b).getTime());
  return Math.floor(ms / (1000 * 60 * 60 * 24));
};
const getDaysUntil = a => {
  return getDaysBetweenDates(a, new Date());
};
export const DateUtils = {
  getDaysBetweenDates,
  getDaysUntil
};
//# sourceMappingURL=date-utils.js.map